import { useReducer } from 'react';
import { type } from './menuStateActions';
import { menuStateReducer } from './menuStateReducer';
import { MenuStateContext } from './MenuStateContext';

const init = () => {
  const menuStatus = localStorage.getItem('menuStatus') || false;
  return {
    open: JSON.parse(menuStatus),
  };
};

export const MenuStateProvider = ({ children }) => {
  const [menuState, dispatch] = useReducer(menuStateReducer, {}, init);

  const toggleMenu = () => {
    const newStatus = !menuState.open;
    localStorage.setItem('menuStatus', newStatus);
    dispatch({ type: type.changeOpen, payload: newStatus });
  };

  return (
    <MenuStateContext.Provider
      value={{
        ...menuState,
        toggleMenu,
      }}
    >
      {children}
    </MenuStateContext.Provider>
  );
};
